"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-has-content */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_1 = __importDefault(require("@gerenciatd/next.components.icon"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_text_info_1 = __importDefault(require("@gerenciatd/next.components.text-info"));
// genero version
const COMPONENT_NAME = "Footer";
//
const TAGGING_INFO = {
    componentVariation: "all",
    componentProduct: "",
    componentName: COMPONENT_NAME,
    componentContent: ``,
};
class Footer extends react_1.Component {
    constructor(props) {
        super(props);
        this.createSpecificClassName = (id) => {
            switch (id) {
                case "cookies":
                    return "optanon-toggle-display";
                default:
                    return "";
            }
        };
        this.handleTogle = (row, column) => {
            const allInfo = Object.assign({}, this.state);
            allInfo[row][column] = !allInfo[row][column];
            this.setState(Object.assign({}, allInfo));
        };
        const state = {
            0: {
                1: false,
                2: false,
                3: false,
                4: false,
            },
            1: {
                1: false,
                2: false,
                3: false,
                4: false,
            },
        };
        this.state = state;
    }
    render() {
        const { footerInfo } = this.props;
        if (!footerInfo || !footerInfo.about || !footerInfo.links) {
            return null;
        }
        if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
            return null;
        }
        const status = this.state;
        const { links, about } = footerInfo;
        const linksKeys = Object.keys(links);
        const aboutKeys = Object.keys(about);
        return (react_1.default.createElement("footer", { id: "footerRoot" },
            react_1.default.createElement("div", { className: "footer xux" },
                react_1.default.createElement("div", { className: "section particulares" },
                    react_1.default.createElement("div", { className: "container footer_container" }, linksKeys.map((key, index) => {
                        const rowIndex = index;
                        const currentRow = links[key];
                        const keytop = `rowIndex-${rowIndex}-${index.toString()}`;
                        return (react_1.default.createElement("div", { key: keytop, className: "footer_row collapsable_menu_row" }, currentRow.map((currentList, indexito) => {
                            const currentClassName = `collapsableMenu collapsableMenu_0_1 collapsableMenu${status[rowIndex][indexito] ? "--show" : "--hidden"}`;
                            const { title, items } = currentList;
                            const cheuronCss = `SvgIconLoader ${status[rowIndex][indexito]
                                ? "icon0-cheuronup-m"
                                : "icon0-cheurondown-m"} SvgIconLoader-color-gp--black SvgIconLoader-bgColor-gp--transparent cheuronTogle`;
                            return (react_1.default.createElement("div", { key: `${keytop}-${indexito}`, className: currentClassName },
                                react_1.default.createElement("div", { className: "collapsableMenu_head particulares" },
                                    react_1.default.createElement("div", { className: "collapsableMenu_head_container particulares" },
                                        react_1.default.createElement(next_components_text_info_1.default, { kind: "span", size: "title05", color: "grey5", text: title, fontType: "font-light", className: "collapsableMenu_title" }),
                                        react_1.default.createElement("span", { className: cheuronCss, style: { fontSize: "1.25rem" } }),
                                        react_1.default.createElement(next_components_custom_link_1.default, { "aria-label": title, title: title, onClick: () => this.handleTogle(rowIndex, indexito), taggingInfo: Object.assign(Object.assign({}, TAGGING_INFO), { componentContent: `Footer-Collapsable-${rowIndex}` }), className: "CustomLink linkoverbox titleLink" })),
                                    react_1.default.createElement("div", { className: "collapsableMenu_items particulares" }, items.map((item) => {
                                        const { id, target, label, link, title: itemTitle, } = item;
                                        return (react_1.default.createElement("div", { key: `${id}-${label}`, className: "item" },
                                            react_1.default.createElement(next_components_custom_link_1.default, { id: id, "aria-label": itemTitle, title: itemTitle, href: link, target: target, taggingInfo: Object.assign(Object.assign({}, TAGGING_INFO), { componentContent: `Footer-link-${link}` }) },
                                                react_1.default.createElement(next_components_text_info_1.default, { kind: "span", size: "caption01", color: "blue", text: label, fontType: "font-light", className: "regularLabel" }))));
                                    })))));
                        })));
                    }))),
                react_1.default.createElement("div", { className: "section sectionrss particulares" },
                    react_1.default.createElement("div", { className: "container footer_container" }, aboutKeys.map((aboutItemKey) => {
                        const currentAboutRow = about[aboutItemKey];
                        const { items, balloonItems, name, title } = currentAboutRow;
                        return (react_1.default.createElement("div", { id: name, key: `about-${name}`, className: `footer_row_link ${name} particulares}` },
                            items && (react_1.default.createElement("div", { className: "items_container particulares" }, items.map((itemLink, indexito) => {
                                const { id, 
                                // title,
                                svgId, label, iconColor, iconSize, link, } = itemLink;
                                // const onClick = this.createSpecificOnClick(id);
                                // const customLinkClassName = this.createSpecificClassName(id);
                                const specialId = `itemLink-${id}-${label || ""}${svgId || ""}-${indexito}`;
                                const lessSpecialId = `itemLink-${id}`;
                                // const svgClassName = `SvgIconLoader icon1-${svgId}-m SvgIconLoader-color-gp--white SvgIconLoader-bgColor-gp--transparent regularIcon`;
                                return (react_1.default.createElement("div", { id: lessSpecialId, key: specialId, className: "itemLink" },
                                    react_1.default.createElement("div", { className: "svgAndLabel" },
                                        svgId && (react_1.default.createElement(next_components_icon_1.default, Object.assign({}, itemLink, { id: svgId, color: iconColor, size: iconSize, style: {
                                                paddingRight: "0.5rem",
                                            } }))),
                                        label && (react_1.default.createElement(next_components_text_info_1.default, { kind: "span", size: "caption01", color: "white", text: label, fontType: "font-light", className: "regularLabel", style: {
                                                paddingLeft: svgId ? "0.5rem" : "0rem",
                                            } }))),
                                    react_1.default.createElement(next_components_custom_link_1.default, { id: id, "aria-label": label, className: this.createSpecificClassName(id), title: label, taggingInfo: Object.assign(Object.assign({}, TAGGING_INFO), { componentContent: `Footer-link-${link}` }), href: link })));
                            }))),
                            balloonItems && (react_1.default.createElement("div", { className: "balloon_container particulares" }, balloonItems.map((ballonItem, bindex) => {
                                const { title: ballonTitle, svgId, label, link, iconSize, iconColor, } = ballonItem;
                                let svgIcon = null;
                                if (svgId) {
                                    svgIcon = (react_1.default.createElement("div", { style: {
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                        } },
                                        react_1.default.createElement(next_components_icon_1.default, { color: iconColor, id: svgId, size: iconSize, className: "ballonIcon" })));
                                }
                                const specialId = `itemBalloon-${label || ""}${svgId || ""}-${bindex}`;
                                const lessSpecialId = `itemBalloon-${svgId || ""}`;
                                return (react_1.default.createElement("div", { id: lessSpecialId, key: specialId, className: "itemLink ballonItem" },
                                    !label && svgIcon && (react_1.default.createElement("div", { className: "balloon particulares" }, svgIcon)),
                                    react_1.default.createElement(next_components_custom_link_1.default, { "aria-label": ballonTitle, title: ballonTitle, href: link, taggingInfo: Object.assign(Object.assign({}, TAGGING_INFO), { componentContent: `Footer-link-${link}` }) })));
                            })))));
                    }))))));
    }
}
const mapStateToProps = (state) => ({
    footerInfo: state.header.footerInfo,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, null)(Footer);
//# sourceMappingURL=index.js.map